import { SharePriceAreaChart } from '@/components/charts/sharePriceAreaChart'
import { DefinitionStat } from '@/components/common/definitionStat'
import type { HistoricalData } from '@/queries/historical.query'
import { getValueColor } from '@/utils/styles/getValueColor'
import type { ReactNode } from 'react'
import { TabHeader } from './tabHeader'

interface Props {
  chartData: HistoricalData
  latestSharePrice: number | null
  periodChange: number | null
  rangeSelector?: ReactNode
  chartClassName?: string
  showBrush?: boolean
}

export const SharePricePerformance = ({
  chartData,
  latestSharePrice,
  periodChange,
  rangeSelector,
  chartClassName,
  showBrush = false,
}: Props) => (
  <div className="flex flex-col gap-4 pt-2">
    <TabHeader
      title="Share price - detailed view"
      description="Value of 1 vault share — tracks your actual profit and loss over time"
    />
    <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-3">
      {latestSharePrice != null && (
        <dl className="flex max-w-full shrink-0 flex-wrap gap-x-8 gap-y-3">
          <DefinitionStat
            label="Latest price"
            value={latestSharePrice.toFixed(4)}
            className="gap-0.5"
            labelClassName="font-normal text-body-foreground"
          />
          {periodChange != null && (
            <DefinitionStat
              label="Period change"
              value={`${periodChange > 0 ? '+' : ''}${periodChange.toFixed(2)}%`}
              className="gap-0.5"
              labelClassName="font-normal text-body-foreground"
              valueClassName={getValueColor(periodChange)}
            />
          )}
        </dl>
      )}
      {rangeSelector && <div className="shrink-0">{rangeSelector}</div>}
    </div>
    <SharePriceAreaChart data={chartData} className={chartClassName} showBrush={showBrush} />
  </div>
)
